module.exports = __webpack_public_path__ + "img/craftBannerIsolationMobile.6d3729b.webp";